import { Injectable } from '@angular/core';
import {AddoSexualAddiction} from "../models/addo/addo-sexual-addiction";
import {SexualAddiction} from "../models/sexual-addiction/sexual-addiction";

import {AddoDepressionReport} from "../models/addo/addo-depression";
import {AddoSexualAddictionSingle} from "../models/addo/addo-sexual-addiction-single";
import {AddoSexualAddictionRelationship} from "../models/addo/addo-sexual-addiction-relationship";
import {AddoOneTimeInfidelitySingle} from "../models/addo/addo-one-time-infidelity-single";
import {AddoOneTimeInfidelityRelationship} from "../models/addo/addo-one-time-infidelity-relationship";
import {AddoGeneralTraumaSingle} from "../models/addo/addo-general-trauma-single";
import {AddoGeneralTraumaRelationship} from "../models/addo/addo-general-trauma-relationship";
import {AddoGeneralSingle} from "../models/addo/addo-general-single";
import {AddoGeneralRelationship} from "../models/addo/addo-general-relationship";
import {SexualBetrayal} from "../models/sexual-betrayal/sexual-betrayal";
import {SexualBetrayalRelationship} from "../models/sexual-betrayal/sexual-betrayal-relationship";


import {DepressionReport} from "../models/depression";
import {DacConfig} from "../../shared/services/dac-config.service";
import { HTTPService } from '../../shared/services/http.service';

import {IReport} from "../models/i-report";
import { Assignment } from 'app/shared/models/Assignment';
import { AssignedAssessment } from 'app/shared/models/AssignedAssessment';
import { ManagedClient } from 'app/shared/models/managed-client';
import { AssignedAssessmentGroup } from 'app/shared/models/AssignedAssessmentGroup';

@Injectable()
export class ReportService {

  private reports:any[];
  private allReportsIncludingHidden:boolean;


  constructor(private dacConfig:DacConfig, private http:HTTPService) { 
    this.reports = null;
  }

  private getReportObjects(showAllReports:boolean = false) : Promise<IReport[]> {
    if (this.reports && this.allReportsIncludingHidden == showAllReports) {

      return Promise.resolve(this.reports);
    }

    return this.http.get("/admin/assessment-reports/", {showAllReports:showAllReports})
      .then((response) => {
        let reports = response.json() as IReport[];
       
        this.reports = reports;
        this.allReportsIncludingHidden = showAllReports;
        return this.reports;
      })
      .catch((error) => {
        console.error(error);
        return [];
      });
  }
  list(showAllReports:boolean = false) : Promise<any[]> {
    return this.getReportObjects(showAllReports);
  }
  
  get(reportId:string) : Promise<any> {
    return this.http.get("/admin/assessment-reports/" + reportId)
      .then((response) => {
        let report = response.json() as IReport;
        return report;
      })
      .catch(error => {
        console.error(error);
        throw Error("Could not find report with id " + reportId);
      });
  }

  create(item:IReport) {
    return this.http.compressedPost("/admin/assessment-reports/", item)
    .then((result) => {
      this.reports = null; // invalidate the cache
      return result;
    });
  }

  save(item:IReport) {
    return this.http.compressedPost("/admin/assessment-reports/" + item.id, item)
    .then((result) => {
      this.reports = null; // invalidate the cache
      return item;
    });
  }
  

  getReportRequirements() : Promise<{id:string, name: string, requirements: string[]}[]> {
    return this.getReportObjects()
      .then(reports => reports.map((r) => {
        let linkedAssessments = r.linkedAssessments || [];
        return {id: r.id, name: r.name, requirements: linkedAssessments};
      }));
  }
  
  getReportsForAssignment(assignment:Assignment) : Promise<{id:string, name:string, requirements:string[]}[]>{
    if (!assignment) {
      return Promise.resolve([]);
    }
    return this.getReportObjects().then(reports => {
      let assignmentReports = [];
      if (assignment.Type == "Assessment") {
        let assessmentAssignment = assignment.Items[0] as AssignedAssessment;
        assignmentReports = reports.filter(r => r.linkedAssessments.length == 1 && r.linkedAssessments[0] == assessmentAssignment.Uid);
      }
      else if (assignment.Type == "AssessmentGroup") {
        let group = assignment as AssignedAssessmentGroup;
        assignmentReports = reports.filter(r => r.linkedGroup && r.linkedGroup.id == group.AssessmentGroupId);
      }
      else if (assignment.Type == 'LibraryAsset') {
        assignmentReports = []; // no reports for now.
      }
      else {
        throw new Error("Unsupported assignment type");
      }
      return assignmentReports;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/services/report.service.ts